import { createSlice } from '@reduxjs/toolkit';
import { TRANSPORT_MODES } from '@App/components/Map/controls/RouteOptions/route-options.constants';

const initialState = {
  homeAddress: undefined,
  searchGeometry: undefined,
  vacancies: [],
  allVacancies: [],
  transportMode: TRANSPORT_MODES[1]?.id,
  currentRouteInfoPanelHeight: 0,
};

const map = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setHomeAddress: (state, action) => {
      state.homeAddress = action.payload?.data;
    },
    setSearchGeometry: (state, action) => {
      state.searchGeometry = action.payload;
    },
    setVacancies: (state, action) => {
      state.vacancies = action.payload;
    },
    setTransportMode: (state, action) => {
      state.transportMode = action.payload;
    },
    setAllVacancies: (state, action) => {
      state.allVacancies = action.payload;
    },
    setCurrentRouteInfoPanelHeight: (state, action) => {
      state.currentRouteInfoPanelHeight = action.payload;
    },
    updateCompanyMobilityOffer: (state, action) => {
      const { OIDN, mobilityOffer } = action.payload;

      state.allVacancies = state.allVacancies.map((v) => {
        if (v.properties.OIDN === OIDN) {
          return {
            ...v,
            properties: {
              ...v.properties,
              mobilityOffer,
            },
          };
        }

        return v;
      });
    },
  },
});

export const {
  setHomeAddress,
  setSearchGeometry,
  setVacancies,
  setTransportMode,
  setAllVacancies,
  setCurrentRouteInfoPanelHeight,
  updateCompanyMobilityOffer,
} = map.actions;

export default map.reducer;
